<template>
  <div id="api_upc_cid9611_iid4519"></div>
</template>

<script>
import { loadScript } from 'vue-plugin-load-script'

export default {
  data () {
    return { }
  },

  mounted () {
    loadScript('https://csub.libcal.com/api_events.php?m=upc&cid=9611&audience=&c=&d=&l=5&simple=ul_date&context=object&format=js')
  }
}
</script>

<style scoped>
</style>
